<template>
    <div class="order-detail-wrapper1" v-if="obj.id">
        <avue-form :option="option" v-model="obj">
            <template slot="starOrderStatusList" slot-scope="scope">
                <el-steps size="mini" :active="obj.starOrderStatusList.length - 1" align-center class="order-steps">
                    <el-step v-for="(item, index) in scope.dic" :title="item.dictValue" :key="index">
                        <template slot="icon" v-if="obj.starOrderStatusList[index]">
                            <el-popover placement="top-start" width="200" trigger="hover">
                                <div v-if="item.dictKey * 1 == 55">
                                    <div class="flex" v-for="(plan, n) in obj.orderInitialPlanList" :key="n">
                                        <div>{{ plan.initPlanCreateDeptName }}</div>
                                        <div>{{ plan.confirmedTime }}</div>
                                    </div>
                                </div>
                                <div v-if="item.dictKey * 1 == 60">
                                    <div v-for="(plan, n) in obj.orderInitialPlanList" :key="n">
                                        <div class="flex">
                                            <div>创建人：{{ obj.starOrderStatusList[index].createUserName }}</div>
                                            <el-button type="text" @click="openJtjhHandle(plan)"
                                                v-if="item.dictKey * 1 == 60">具体计划单</el-button>
                                        </div>
                                        <div>机构：{{ obj.starOrderStatusList[index].createDeptName }}</div>
                                        <div>
                                            时间：{{ obj.starOrderStatusList[index] ? getDateFormate(obj.starOrderStatusList[index].createTime) : '' }}
                                        </div>
                                    </div>
                                </div>
                                <div v-else>
                                    <div class="flex">
                                        <div>创建人：{{ obj.starOrderStatusList[index].createUserName }}</div>
                                        <el-button type="text" @click="orderDetailVisible = true"
                                            v-if="item.dictKey * 1 == 20 || item.dictKey * 1 == 30 || item.dictKey * 1 == 70 || item.dictKey * 1 == 80 || item.dictKey * 1 == 90">详情</el-button>
                                        <el-button type="text" @click="pdflVisible = true"
                                            v-if="item.dictKey * 1 == 40 || item.dictKey * 1 == 50">计划单</el-button>
                                        <el-button type="text" @click="pdflVisible1 = true"
                                            v-if="item.dictKey * 1 == 40">社会调查</el-button>
                                        <!-- <el-button type="text" @click="pdfljtVisible=true" v-if="item.dictKey*1 == 60">具体计划单</el-button> -->
                                        <el-button type="text" @click="pdfOnlinelVisible = true"
                                            v-if="item.dictKey * 1 == 100">查看</el-button>
                                    </div>
                                    <div>机构：{{ obj.starOrderStatusList[index].createDeptName }}</div>
                                    <div>
                                        时间：{{ obj.starOrderStatusList[index] ? getDateFormate(obj.starOrderStatusList[index].createTime) : '' }}
                                    </div>
                                </div>
                                <div slot="reference" @click="openDetailDialog(obj.starOrderStatusList[index])">
                                    <b>{{ index + 1 }}</b></div>
                            </el-popover>
                        </template>
                        <template slot="description">
                            <div class="c9">
                                {{ obj.starOrderStatusList[index] ? obj.starOrderStatusList[index].createUserName : '' }}
                            </div>
                            <div class="c9">
                                {{ obj.starOrderStatusList[index] ? getDateFormate(obj.starOrderStatusList[index].createTime) : '' }}
                            </div>
                        </template>
                    </el-step>
                </el-steps>
            </template>
            <template slot="initialPlanNo">
                <div class="num-family">{{ obj.initialPlanNo }}</div>
            </template>
            <template slot="orderNo">
                <div class="num-family">{{ obj.orderNo }}</div>
            </template>
            <template slot="qsgx">
                <kinship :isShowBtn="false" :isOpt="false" :isShowTitle="false" :orderId="obj.id"
                    :list="obj.orderKinshipList"></kinship>
            </template>
            <template slot="rjgx">
                <relation :isShowBtn="false" :isOpt="false" :isShowTitle="false" :orderId="obj.id"
                    :list="obj.orderRelationList"></relation>
            </template>
            <template slot="residenceProvince">
                <div class="txt">
                    {{ obj.orderPersonalData.residenceProvince }}{{ obj.orderPersonalData.residenceCity }}{{ obj.orderPersonalData.residenceDistrict }}{{ obj.orderPersonalData.residenceAddress }}
                </div>
            </template>
            <template slot="actualResidenceProvince">
                <div class="txt">
                    {{ obj.orderPersonalData.actualResidenceProvince }}{{ obj.orderPersonalData.actualResidenceCity }}{{ obj.orderPersonalData.actualResidenceDistrict }}{{ obj.orderPersonalData.actualResidentialAddress }}
                </div>
            </template>
            <template slot="jhd">
                <orderinit :isShowBtn="false" :isOpt="false" :isSee="true" :isShowTitle="false" :orderId="obj.id"
                    :list="obj.orderInitialPlanList"></orderinit>
            </template>
            <template slot="detailInit">
                <orderinitDetail :isShowTitle="false" :isOpt="false" :isSee="true" :isShowBtn="false"
                    :list="obj.orderInitialPlanList" :date="new Date()"></orderinitDetail>
            </template>
            <template slot="gjf">
                <orderjudicial :isShowBtn="task ? true : false" :isOpt="false" :isSee="true" :isShowTitle="false"
                    :orderId="obj.id" :list="obj.starOrderJudicialList"></orderjudicial>
                <!-- <div class="mt10">注：该凭证号条形码同时生成至上传的凭证文件上左上角；PDF417条形码在右上角。</div> -->
            </template>
        </avue-form>
        <div class="tac mt20">
            <el-button type="primary" size="mini" @click="closeVisible">返回</el-button>
            <el-button type="primary" v-if="printBtn" size="mini" @click="orderDetailVisible = true">打印</el-button>
            <el-button type="primary" v-if="obj.status >= 40" size="mini"
                @click="orderDispatchVisible = true">派单记录</el-button>
            <el-button type="primary" v-if="permission.order_close_case && obj.isManualCase == 1" size="mini"
                @click="manualCaseHandle">结案</el-button>
            <el-button type="primary" v-if="printBtn && obj.orderSocialSurvey.id" size="mini"
                @click="pdflVisible1 = true">社会调查报告</el-button>
            <el-button type="primary" v-if="printBtn && obj.orderInitialPlanList.length > 0" size="mini"
                @click="pdflVisible = true">打印计划单</el-button>
            <el-button type="primary" size="mini" v-if="printBtn && obj.starOrderJudicialList.length > 0"
                @click.stop="pdfpzVisible = true">打印凭证
            </el-button>
            <el-button type="primary" v-if="printBtn && obj.status >= 60" size="mini"
                @click="pdfljtVisible = true">具体计划单</el-button>
            <el-button type="primary" v-if="printBtn && obj.status == 100" size="mini"
                @click="pdfOnlinelVisible = true">打印报告</el-button>
            <el-button type="primary" v-if="examineBtn || lastExamine" size="mini"
                @click="examinelVisible = true">审核</el-button>
            <el-button type="primary" v-if="pfBtn" size="mini"
                @click="!evaluate ? pfVisible = true : ''">{{ evaluate ? '已评价' : '评价评分' }}</el-button>
        </div>
        <el-dialog title="审核" append-to-body width="600px" :visible.sync="examinelVisible">
            <avue-form ref="examineForm" v-model="examineForm" :option="examineOption" @submit="submit">
            </avue-form>
        </el-dialog>
        <el-dialog title="初始计划单" append-to-body width="80%" :visible.sync="pdflVisible" custom-class="common-dialog"
            class="avue-dialog">
            <csPdf :info="detail" @close="pdflVisible = false"></csPdf>
        </el-dialog>
        <el-dialog title="订单详情" fullscreen append-to-body width="80%" :visible.sync="orderDetailVisible">
            <pdf :info="detail" :type="1" @close="orderDetailVisible = false"></pdf>
        </el-dialog>
        <el-dialog title="公检司法凭证" append-to-body width="80%" :visible.sync="pdfpzVisible" custom-class="common-dialog"
            class="avue-dialog">
            <gjfPdf :info="detail" @close="pdfpzVisible = false"></gjfPdf>
        </el-dialog>
        <el-dialog title="社会调查报告" append-to-body width="100%" :visible.sync="pdflVisible1" custom-class="common-dialog"
            class="avue-dialog">
            <investpdf :info="detail" @close="pdflVisible1 = false"></investpdf>
        </el-dialog>
        <el-dialog title="具体计划单" append-to-body width="80%" :visible.sync="pdfljtVisible" custom-class="common-dialog"
            class="avue-dialog">
            <jtPdf :info="jtjhDetail" @close="pdfljtVisible = false"></jtPdf>
        </el-dialog>
        <el-dialog title="查看报告" append-to-body width="80%" :visible.sync="pdfOnlinelVisible"
            custom-class="common-dialog" class="avue-dialog">
            <reportpdf :info="detail" @close="pdfOnlinelVisible = false"></reportpdf>
        </el-dialog>
        <el-dialog title="评价评分" :append-to-body="true" width="600px" :visible.sync="pfVisible">
            <avue-form ref="pfForm" v-model="pfForm" :option="pfOption" @submit="examineSubmit">
            </avue-form>
        </el-dialog>
        <el-dialog title="派单记录" fullscreen append-to-body width="80%" :visible.sync="orderDispatchVisible"
            v-if="orderDispatchVisible">
            <dispatchRecord :orderId="detail.id" :date="new Date()"></dispatchRecord>
        </el-dialog>
    </div>
</template>
<script>
import { mapGetters } from "vuex";
import { orderManualCase, orderEvaluationHandle, isOrderEvaluation } from '@/api/order/index'
import orderjudicial from '@/components/orderjudicial/index.vue'
import kinship from '@/components/kinship/index.vue'
import orderinit from '@/components/orderinit/index.vue'
import relation from '@/components/relation/index.vue'
import pdf from '@/views/archives/components/order-detail-pdf.vue'
import csPdf from '@/views/archives/components/lzjh-pdf.vue'
import { dateFormat } from "@/util/date"
import { deepClone } from '@/util/util'
import { updateStatus, auditTwoHandle, auditOneHandle } from "@/api/order/index";
import orderinitDetail from '@/components/orderinit/detail.vue'
import { getDictTree, getDictionary } from "@/api/system/dictbiz"
import gjfPdf from '@/views/archives/components/gjf-pdf.vue'
import jtPdf from '@/views/archives/components/jtjh-pdf.vue'
import investpdf from '@/views/archives/components/investigation-pdf.vue'
import reportpdf from '@/views/archives/components/report-pdf.vue'
import dispatchRecord from '@/components/orderlp/record.vue'
export default {
    name: 'order-detail',
    props: {
        detail: {
            type: Object,
            default: {}
        },
        printBtn: {
            type: Boolean,
            default: false
        },
        examineBtn: {
            type: Boolean,
            default: false
        },
        lastExamine: {
            type: Boolean,
            default: false
        },
        task: {
            type: Boolean,
            default: false
        },
        pfBtn: {
            type: Boolean,
            default: false
        }
    },
    components: {
        orderjudicial,
        kinship,
        orderinit,
        pdf,
        relation,
        orderinitDetail,
        csPdf,
        gjfPdf,
        investpdf,
        jtPdf,
        reportpdf,
        dispatchRecord
    },
    computed: {
        ...mapGetters(["permission"]),
        getDateFormate() {
            return function (date) {
                return dateFormat(new Date(date), "yyyy-MM-dd")
            }
        }
    },
    watch: {
        detail: {
            deep: true,
            handler(val) {
                this.init()
            }
        },
        pfBtn: {
            deep: true,
            handler(val) {
                isOrderEvaluation(this.detail.id).then(res => {
                    this.evaluate = res.data.data * 1 == 0 ? false : true

                })
            },
            immediate: true
        }
    },
    data() {
        return {
            evaluate: false, // 是否评价了
            pfVisible: false,
            pfForm: {},
            pfOption: {
                column: [{
                    label: '评分',
                    prop: 'score',
                    row: true,
                    span: 24,
                    dataType: 'number',
                    type: "rate",
                    rules: [{
                        required: true,
                        message: "请选择状态",
                        trigger: "click"
                    }]
                },
                {
                    label: '说明',
                    prop: 'note',
                    row: true,
                    span: 24,
                    type: "textarea",
                    rules: [{
                        required: true,
                        message: "请填写原因",
                        trigger: "click"
                    }]
                }
                ]
            },
            jtjhDetail: {},
            pdfOnlinelVisible: false,
            pdfljtVisible: false,
            pdflVisible1: false,
            pdfpzVisible: false,
            pdflVisible: false,
            orderDispatchVisible: false,
            examinelVisible: false,
            examineForm: {},
            examineOption: {
                column: [{
                    label: '状态',
                    prop: 'result',
                    row: true,
                    span: 24,
                    dataType: 'number',
                    type: "select",
                    props: {
                        label: "dictValue",
                        value: "dictKey"
                    },
                    rules: [{
                        required: true,
                        message: "请选择状态",
                        trigger: "click"
                    }],
                    change: (value) => {
                        let column = this.examineOption.column.find(v => v.prop == "remark")
                        if (value.value * 1 == 2) {
                            column.display = true
                            this.examineForm.remark = ""
                        } else {
                            column.display = false
                        }
                    },
                },
                {
                    label: '原因',
                    prop: 'remark',
                    row: true,
                    display: false,
                    span: 24,
                    type: "textarea",
                    rules: [{
                        required: true,
                        message: "请填写原因",
                        trigger: "click"
                    }]
                }
                ]
            },
            orderDetailVisible: false,
            obj: {},
            orderKinshipList: [],
            starOrderJudicialList: [],
            option: {
                detail: true,
                group: [{
                    label: '订单信息',
                    prop: 'group1',
                    arrow: false,
                    column: [{
                        label: '订单号',
                        prop: 'orderNo',
                        span: 8
                    }, {
                        label: '计划单号',
                        prop: 'initialPlanNo',
                        span: 16
                    }, {
                        label: '经办人',
                        prop: 'orderCreateUserName',
                        span: 8
                    }, {
                        label: "订单类型",
                        prop: "type",
                        type: "select",
                        dataType: 'string',
                        dicUrl: "/api/blade-system/dict-biz/dictionary",
                        dicQuery: {
                            code: 'work_type',
                        },
                        formatter: (row, value, label, column) => {
                            return label
                        },
                        props: {
                            label: "dictValue",
                            value: "dictKey"
                        },
                        span: 8
                    }, {
                        label: "优先级",
                        prop: "priority",
                        bind: 'orderPersonalData.priority',
                        type: "select",
                        dicUrl: "/api/blade-system/dict-biz/dictionary",
                        dicQuery: {
                            code: 'priority'
                        },

                        props: {
                            label: "dictValue",
                            value: "dictKey"
                        },
                        span: 8
                    }, {
                        label: "五类青少年",
                        prop: "teenagersType",
                        bind: 'orderPersonalData.teenagersType',
                        type: "select",
                        dicUrl: "/api/blade-system/dict-biz/dictionary",
                        dicQuery: {
                            code: 'Five-youth_types'
                        },
                        props: {
                            label: "dictValue",
                            value: "dictKey"
                        },
                        span: 8
                    }, {
                        label: '状态',
                        prop: 'status',
                        span: 8,
                        type: "select",
                        dataType: 'number',
                        dicUrl: "/api/blade-system/dict-biz/dictionary",
                        dicQuery: {
                            code: 'order_status'
                        },
                        props: {
                            label: "dictValue",
                            value: "dictKey"
                        },
                    }, {
                        label: '发布时间',
                        prop: 'createTime',
                        span: 8
                    }, {
                        label: '完成时间',
                        prop: 'finishTime',
                        span: 8
                    }, {
                        label: "颜色标注",
                        prop: "orderColor",
                        type: "select",
                        dicUrl: "/api/blade-system/dict-biz/dictionary",
                        dicQuery: {
                            code: 'Color'
                        },
                        props: {
                            label: "dictValue",
                            value: "dictKey"
                        },
                        span: 8
                    }, {
                        label: '服务机构',
                        prop: 'orderCreateDeptName',
                        // dataType: 'number',
                        // type: "tree",
                        // dicUrl: "/api/blade-system/dept/tree",
                        // props: {
                        //     label: "title",
                        // },
                        // formatter: (row, value, label, column) => {
                        //     return label
                        // },
                        span: 8
                    }]
                },
                {
                    label: '流程进度',
                    arrow: false,
                    prop: 'group2',
                    column: [{
                        labelWidth: '0',
                        prop: 'starOrderStatusList',
                        span: 24,
                        formslot: true,
                        row: true,
                        type: "select",
                        dicData: [],
                        props: {
                            label: "dictValue",
                            value: "dictKey"
                        },
                    },]
                },
                {
                    label: '用户信息',
                    arrow: false,
                    prop: 'group3',
                    column: [{
                        label: "头像",
                        prop: "photoUrl",
                        bind: 'orderPersonalData.photoUrl',
                        type: 'upload',
                        listType: 'picture-img',
                        span: 24,
                        row: true
                    }, {
                        label: '姓名',
                        prop: 'name',
                        bind: "orderPersonalData.name",
                        span: 8
                    }, {
                        label: '出生年月',
                        prop: 'birthday',
                        bind: "orderPersonalData.birthday",
                        span: 8
                    }, {
                        label: '籍贯',
                        prop: 'nativePlace',
                        bind: "orderPersonalData.nativePlace",
                        span: 8
                    }, {
                        label: "身份证",
                        prop: "cardNo",
                        bind: 'orderPersonalData.cardNo',
                        span: 8
                    }, {
                        label: "性别",
                        prop: "gender",
                        bind: 'orderPersonalData.gender',
                        type: 'select',
                        dataType: "number",
                        dicUrl: "/api/blade-system/dict-biz/dictionary",
                        dicQuery: {
                            code: 'sex'
                        },
                        props: {
                            label: "dictValue",
                            value: "dictKey"
                        },
                        span: 8
                    }, {
                        label: '健康状态',
                        prop: 'healthyState',
                        bind: "orderPersonalData.healthyState",
                        span: 8,
                        dataType: 'number',
                        type: "select",
                        dicUrl: "/api/blade-system/dict-biz/dictionary",
                        dicQuery: {
                            code: 'healthy'
                        },
                        props: {
                            label: "dictValue",
                            value: "dictKey"
                        }
                    }, {
                        label: '联系方式',
                        prop: 'contact',
                        bind: "orderPersonalData.contact",
                        span: 8
                    }, {
                        label: '户籍地址',
                        prop: 'residenceProvince',
                        bind: "orderPersonalData.residenceProvince",
                        formslot: true,
                        span: 24,
                        row: true,
                    }, {
                        label: '现住地址',
                        prop: 'actualResidenceProvince',
                        bind: "orderPersonalData.actualResidenceProvince",
                        formslot: true,
                        span: 24,
                        row: true
                    }]
                },
                {
                    label: '案件描述',
                    arrow: false,
                    prop: 'group4',
                    labelWidth: 120,
                    column: [{
                        labelWidth: 72,
                        label: "案件类型",
                        prop: "crimeTypeName",
                        // type: 'select',
                        // dataType: "string",
                        // dicUrl: "/api/blade-system/dict-biz/dictionary",
                        // dicQuery: {
                        //     code: 'crime_types'
                        // },
                        // props: {
                        //     label: "dictValue",
                        //     value: "dictKey"
                        // },
                        span: 12,
                        // row: true,
                        // lazy:true
                    },
                    {
                        labelWidth: 72,
                        label: "涉案时间",
                        prop: "crimeTime",
                        type: "datetime",
                        span: 12,
                    }, {
                        labelWidth: 72,
                        label: "涉案区域",
                        prop: "regionCodeName",
                        span: 12,
                    }, {
                        labelWidth: 72,
                        label: "涉案场所",
                        prop: "placeTypeName",
                        span: 12,
                    },
                    {
                        labelWidth: 72,
                        label: "情况描述",
                        prop: "crimeSituation",
                        type: 'textarea',
                        span: 24
                    },
                    //  {
                    //     labelWidth: 72,
                    //     label: "危险因素",
                    //     prop: "hazard",
                    //     type: "select",
                    //     dicUrl: "/api/blade-system/dict-biz/dictionary",
                    //     props: {
                    //         label: "dictValue",
                    //         value: "dictKey"
                    //     },
                    //     dicQuery: {
                    //         code: 'critical_factors_ype'
                    //     },
                    //     span: 24
                    // }, {
                    //     labelWidth: 100,
                    //     label: "危急因素备注",
                    //     prop: "hazardRemark",
                    //     span: 24
                    // },
                    {
                        labelWidth: 72,
                        label: "紧急服务",
                        prop: "emergencyServices",
                        type: "select",
                        dataType: "number",
                        dicData: [{
                            label: '需要',
                            value: 0
                        }, {
                            label: '不需要',
                            value: 1
                        }],
                        span: 24
                    }, {
                        labelWidth: 100,
                        label: "紧急服务备注",
                        prop: "emergencyServicesRemarks",
                        span: 24
                    },
                        // {
                        //     labelWidth: 72,
                        //     label: '案情概述',
                        //     prop: 'summarize',
                        //     span: 24,
                        //     formslot: true,
                        //     row: true
                        // }, {
                        //     labelWidth: 72,
                        //     label: '案情详情',
                        //     prop: 'detail',
                        //     span: 24,
                        //     formslot: true,
                        //     row: true
                        // }
                    ]
                },
                {
                    label: '服务情况',
                    arrow: false,
                    prop: 'group7',
                    labelWidth: 120,
                    column: [{
                        label: "曾经有使用相关服务记录",
                        labelWidth: 170,
                        prop: "isServiceSituation",
                        bind: 'orderPersonalData.isServiceSituation',
                        type: "select",
                        dataType: "number",
                        dicData: [{
                            label: '没有',
                            value: 0
                        }, {
                            label: '曾经有',
                            value: 1
                        }]
                    }, {
                        label: "曾经有注明",
                        prop: "serviceSituationRemarks",
                        bind: 'orderPersonalData.serviceSituationRemarks'
                    },
                    {
                        label: "现使用相关服务记录",
                        labelWidth: 170,
                        prop: "serviceSituationRecord",
                        bind: 'orderPersonalData.serviceSituationRecord',
                        type: "select",
                        dataType: "number",
                        dicData: [{
                            label: '没有',
                            value: 0
                        }, {
                            label: '现没有',
                            value: 1
                        }]
                    }, {
                        label: "现有注明",
                        prop: "serviceSituationNow",
                        bind: 'orderPersonalData.serviceSituationNow'
                    }
                    ]
                },
                {
                    label: '社会调查',
                    prop: 'sociology',
                    column: [{
                        label: "调查时间",
                        prop: "surveyTime",
                        bind: 'orderSocialSurvey.surveyTime',
                        type: "date",
                        format: "yyyy-MM-dd",
                        valueFormat: "yyyy-MM-dd hh:mm:ss",
                        hide: true,
                        rules: [{
                            required: true,
                            trigger: "blur"
                        }]
                    }, {
                        label: "调查主体",
                        prop: "surveyMain",
                        bind: 'orderSocialSurvey.surveyMain',
                        rules: [{
                            required: true,
                            trigger: "blur"
                        }]
                    }, {
                        label: "调查方式",
                        prop: "surveyMethod",
                        bind: 'orderSocialSurvey.surveyMethod',
                        type: "select",
                        dicUrl: "/api/blade-system/dict-biz/dictionary",
                        dicQuery: {
                            code: 'Investigation_method'
                        },
                        props: {
                            label: "dictValue",
                            value: "dictKey"
                        },
                        rules: [{
                            required: true,
                            trigger: "blur"
                        }]
                    },
                    {
                        label: "记录人",
                        prop: "record",
                        bind: 'orderSocialSurvey.record',
                        rules: [{
                            required: true,
                            trigger: "blur"
                        }]
                    },
                    {
                        label: "综合特质",
                        prop: "comprehensive",
                        bind: 'orderSocialSurvey.comprehensive',
                        type: "textarea",
                        span: 24,
                        placeholder: '提示：xxx体型稍胖，案主陈述性格较为内向、话较少'
                    }, {
                        label: "生活习惯",
                        prop: "livingHabits",
                        bind: 'orderSocialSurvey.livingHabits',
                        type: "textarea",
                        span: 24,
                        placeholder: '提示：xxx大多数时间都是宅在家里较少出去，爱打网络游戏，爱好打篮球（活动范围基本在居住地附近），生活作息叫规律'
                    }, {
                        label: "身高",
                        prop: "height",
                        bind: 'orderSocialSurvey.height',
                        type: "select",
                        dicUrl: "/api/blade-system/dict-biz/dictionary",
                        dicQuery: {
                            code: 'height'
                        },
                        props: {
                            label: "dictValue",
                            value: "dictKey"
                        },
                    }, {
                        label: "体重",
                        prop: "weight",
                        bind: 'orderSocialSurvey.weight',
                        type: "select",
                        dicUrl: "/api/blade-system/dict-biz/dictionary",
                        dicQuery: {
                            code: 'weight'
                        },
                        props: {
                            label: "dictValue",
                            value: "dictKey"
                        },
                    }, {
                        label: "情绪",
                        prop: "mood",
                        bind: 'orderSocialSurvey.mood',
                        type: "select",
                        dicUrl: "/api/blade-system/dict-biz/dictionary",
                        dicQuery: {
                            code: 'emotional'
                        },
                        props: {
                            label: "dictValue",
                            value: "dictKey"
                        },
                    }, {
                        label: "性格",
                        prop: "isCharacter",
                        bind: 'orderSocialSurvey.isCharacter',
                        type: "select",
                        dicUrl: "/api/blade-system/dict-biz/dictionary",
                        dicQuery: {
                            code: 'character'
                        },
                        props: {
                            label: "dictValue",
                            value: "dictKey"
                        },

                    }, {
                        label: '性格说明备注',
                        labelWidth: 120,
                        prop: 'isCharacterRemarks',
                        bind: 'orderSocialSurvey.isCharacterRemarks',
                        span: 12,

                    }, {
                        label: "是否有纹身",
                        prop: "isTattoo",
                        bind: 'orderSocialSurvey.isTattoo',
                        type: "select",
                        dicUrl: "/api/blade-system/dict-biz/dictionary",
                        dicQuery: {
                            code: 'there_tattoo'
                        },
                        props: {
                            label: "dictValue",
                            value: "dictKey"
                        },
                    }, {
                        label: "不良嗜好",
                        prop: "habits",
                        bind: 'orderSocialSurvey.habits',
                        type: "select",
                        dicUrl: "/api/blade-system/dict-biz/dictionary",
                        dicQuery: {
                            code: 'bad_hobby'
                        },
                        props: {
                            label: "dictValue",
                            value: "dictKey"
                        },
                    },
                    {
                        label: "是否有手淫行为",
                        labelWidth: 115,
                        prop: "isMasturbation",
                        bind: 'orderSocialSurvey.isMasturbation',
                        type: "select",
                        dicUrl: "/api/blade-system/dict-biz/dictionary",
                        dicQuery: {
                            code: 'Masturbation'
                        },
                        props: {
                            label: "dictValue",
                            value: "dictKey"
                        },
                    },
                    {
                        label: "是否有观看淫秽视频行为",
                        labelWidth: 186,
                        prop: "isVideo",
                        bind: 'orderSocialSurvey.isVideo',
                        type: "select",
                        dicUrl: "/api/blade-system/dict-biz/dictionary",
                        dicQuery: {
                            code: 'Obscene_video'
                        },
                        props: {
                            label: "dictValue",
                            value: "dictKey"
                        },
                    }, {
                        label: "是否有打架经历",
                        labelWidth: 115,
                        prop: "isFight",
                        bind: 'orderSocialSurvey.isFight',
                        type: "select",
                        dicUrl: "/api/blade-system/dict-biz/dictionary",
                        dicQuery: {
                            code: 'Fighting_experience'
                        },
                        props: {
                            label: "dictValue",
                            value: "dictKey"
                        },
                    }, {
                        label: "是否经常出入娱乐场所",
                        labelWidth: 170,
                        prop: "isEntertainment",
                        bind: 'orderSocialSurvey.isEntertainment',
                        type: "select",
                        dicUrl: "/api/blade-system/dict-biz/dictionary",
                        dicQuery: {
                            code: 'Entertainment_place'
                        },
                        props: {
                            label: "dictValue",
                            value: "dictKey"
                        },
                    }, {
                        label: "是否夜不归宿行为",
                        labelWidth: 129,
                        prop: "isWantTo",
                        bind: 'orderSocialSurvey.isWantTo',
                        type: "select",
                        dicUrl: "/api/blade-system/dict-biz/dictionary",
                        dicQuery: {
                            code: 'Nocturnal_behavior'
                        },
                        props: {
                            label: "dictValue",
                            value: "dictKey"
                        },
                    }, {
                        label: "作息时间",
                        prop: "workTime",
                        bind: 'orderSocialSurvey.workTime',
                        type: "select",
                        dicUrl: "/api/blade-system/dict-biz/dictionary",
                        dicQuery: {
                            code: 'Time_Table'
                        },
                        props: {
                            label: "dictValue",
                            value: "dictKey"
                        },
                    }, {
                        label: "是否有犯罪前科",
                        labelWidth: 116,
                        prop: "isCriminalRecord",
                        bind: 'orderSocialSurvey.isCriminalRecord',
                        type: "select",
                        dicUrl: "/api/blade-system/dict-biz/dictionary",
                        dicQuery: {
                            code: 'Criminal_record'
                        },
                        props: {
                            label: "dictValue",
                            value: "dictKey"
                        },
                    }, {
                        label: "是否喜欢网络游戏",
                        labelWidth: 139,
                        prop: "isOnlineGame",
                        bind: 'orderSocialSurvey.isOnlineGame',
                        type: "select",
                        dicUrl: "/api/blade-system/dict-biz/dictionary",
                        dicQuery: {
                            code: 'network_game'
                        },
                        props: {
                            label: "dictValue",
                            value: "dictKey"
                        },
                    }, {
                        label: "在校处分情况",
                        labelWidth: 101,
                        prop: "isDisciplinary",
                        bind: 'orderSocialSurvey.isDisciplinary',
                        type: "select",
                        dicUrl: "/api/blade-system/dict-biz/dictionary",
                        dicQuery: {
                            code: 'punishment'
                        },
                        props: {
                            label: "dictValue",
                            value: "dictKey"
                        },
                    }, {
                        label: "是否有旷课行为",
                        labelWidth: 123,
                        prop: "isTruancy",
                        bind: 'orderSocialSurvey.isTruancy',
                        type: "select",
                        dicUrl: "/api/blade-system/dict-biz/dictionary",
                        dicQuery: {
                            code: 'Absenteeism'
                        },
                        props: {
                            label: "dictValue",
                            value: "dictKey"
                        },
                    }, {
                        label: "法律法规认知程度",
                        labelWidth: 135,
                        prop: "isRegulations",
                        bind: 'orderSocialSurvey.isRegulations',
                        type: "select",
                        dicUrl: "/api/blade-system/dict-biz/dictionary",
                        dicQuery: {
                            code: 'Awareness-laws_regulations'
                        },
                        props: {
                            label: "dictValue",
                            value: "dictKey"
                        },
                    }, {
                        label: "就读状况",
                        prop: "studentStatus",
                        bind: 'orderSocialSurvey.studentStatus',
                        type: "select",
                        dataType: "number",
                        dicUrl: "/api/blade-system/dict-biz/dictionary",
                        dicQuery: {
                            code: 'Academic_status'
                        },
                        props: {
                            label: "dictValue",
                            value: "dictKey"
                        },
                    }, {
                        label: "学校",
                        prop: "school",
                        bind: 'orderSocialSurvey.school'
                    }, {
                        label: "学业阶段",
                        prop: "academicStage",
                        bind: 'orderSocialSurvey.academicStage',
                        type: "select",
                        dataType: "number",
                        dicUrl: "/api/blade-system/dict-biz/dictionary",
                        dicQuery: {
                            code: 'Academic_stage'
                        },
                        props: {
                            label: "dictValue",
                            value: "dictKey"
                        },
                    },
                    {
                        label: "年级",
                        prop: "theGrade",
                        bind: 'orderSocialSurvey.theGrade'
                    },
                    {
                        label: "班级",
                        prop: "theClass",
                        bind: 'orderSocialSurvey.theClass'
                    },
                    {
                        label: "学籍号",
                        prop: "studentNo",
                        bind: 'orderSocialSurvey.studentNo'
                    },
                    {
                        label: "学习成绩",
                        prop: "studyResult",
                        bind: 'orderSocialSurvey.studyResult',
                        type: "select",
                        dicUrl: "/api/blade-system/dict-biz/dictionary",
                        dicQuery: {
                            code: 'academic_record'
                        },
                        props: {
                            label: "dictValue",
                            value: "dictKey"
                        },
                    },
                    {
                        label: "学习经历",
                        prop: "studyExperience",
                        bind: 'orderSocialSurvey.studyExperience',
                        type: "textarea",
                        placeholder: "小学毕业于XXX中心小学；初中毕业于XXX中；目前就读于福州市XXX中学；XXX自述学习成绩一般，较少主动和同学交流互动，放学后都准时回家，偶尔早放学时会与同学一起打篮球。",
                        span: 24
                    },
                    {
                        label: "就业状况",
                        prop: "employmentStatus",
                        bind: 'orderSocialSurvey.employmentStatus',
                        type: "select",
                        dataType: "number",
                        dicData: [{
                            label: '已就业',
                            value: 0
                        }, {
                            label: '未就业',
                            value: 1
                        }]
                    }, {
                        label: "就业单位",
                        prop: "employmentUnit",
                        bind: 'orderSocialSurvey.employmentUnit'
                    },
                    {
                        label: '婚恋问题',
                        prop: 'marriageProblems',
                        bind: 'orderSocialSurvey.marriageProblems',
                        type: "select",
                        dicUrl: '/api/blade-system/dict-biz/dictionary',
                        dicQuery: {
                            code: 'yes_no'
                        },
                        dataType: "number",
                        props: {
                            label: "dictValue",
                            value: "dictKey"
                        },
                    }, {
                        label: '婚恋备注',
                        prop: 'marriageProblemsRemark',
                        bind: 'orderSocialSurvey.marriageProblemsRemark',
                        span: 12,

                    },
                    {
                        label: '经济援助',
                        prop: 'financialAid',
                        bind: 'orderSocialSurvey.financialAid',
                        type: "select",
                        dicUrl: '/api/blade-system/dict-biz/dictionary',
                        dicQuery: {
                            code: 'yes_no'
                        },
                        dataType: "number",
                        props: {
                            label: "dictValue",
                            value: "dictKey"
                        },
                    }, {
                        label: '经济援助备注',
                        labelWidth: 110,
                        prop: 'financialAidRemark',
                        bind: 'orderSocialSurvey.financialAidRemark',
                        span: 12,
                    },
                    {
                        label: '家庭暴力问题',
                        labelWidth: 110,
                        prop: 'domesticViolence',
                        bind: 'orderSocialSurvey.domesticViolence',
                        dicUrl: '/api/blade-system/dict-biz/dictionary',
                        type: 'select',
                        dicQuery: {
                            code: 'family_violence'
                        },
                        dataType: "number",
                        props: {
                            label: "dictValue",
                            value: "dictKey"
                        }
                    },
                    {
                        label: '家庭暴力备注',
                        labelWidth: 110,
                        prop: 'domesticViolenceRemark',
                        bind: 'orderSocialSurvey.domesticViolenceRemark',
                        span: 12,

                    },
                    {
                        label: "处理记录",
                        prop: "processingRecord",
                        bind: 'orderSocialSurvey.processingRecord',
                        type: 'textarea',
                        span: 24
                    }, {
                        label: "服务情况",
                        prop: "serviceSituation",
                        bind: 'orderSocialSurvey.serviceSituation',
                        type: 'textarea',
                        span: 24
                    },
                    ]
                },
                {
                    label: '家庭情况',
                    prop: 'family',
                    column: [{
                        label: '家庭类型',
                        prop: 'householdType',
                        bind: 'orderPersonalData.householdType',
                        type: "select",
                        dicUrl: "/api/blade-system/dict-biz/dictionary",
                        dicQuery: {
                            code: 'household_type'
                        },
                        props: {
                            label: "dictValue",
                            value: "dictKey"
                        },
                        span: 12,
                    }, {
                        label: "家庭教养",
                        prop: "familyUpbringing",
                        bind: 'orderPersonalData.familyUpbringing',
                        type: "select",
                        dicUrl: "/api/blade-system/dict-biz/dictionary",
                        dicQuery: {
                            code: 'parenting_pattern'
                        },
                        props: {
                            label: "dictValue",
                            value: "dictKey"
                        },
                        row: true
                    },
                    {
                        label: "家庭经济",
                        prop: "familyEconomy",
                        bind: 'orderPersonalData.familyEconomy',
                        type: "select",
                        dicUrl: "/api/blade-system/dict-biz/dictionary",
                        dicQuery: {
                            code: 'Family-economic_status'
                        },
                        props: {
                            label: "dictValue",
                            value: "dictKey"
                        },
                        row: true
                    },
                    {
                        labelWidth: 0,
                        prop: 'familyNote',
                        bind: 'orderPersonalData.familyNote',
                        type: 'textarea',
                        span: 24,
                        placeholder: '简要说明'
                    }
                    ]
                },
                {
                    label: '亲属关系',
                    arrow: false,
                    prop: 'qs',
                    labelWidth: 0,
                    column: [{
                        prop: 'qsgx',
                        span: 24,
                        row: true
                    }]
                }, {
                    label: '人际关系',
                    arrow: false,
                    prop: 'rj',
                    labelWidth: 0,
                    column: [{
                        prop: 'rjgx',
                        span: 24,
                        row: true
                    }]
                }, {
                    label: '在社区或单位表现',
                    prop: 'bx',
                    column: [{
                        labelWidth: 0,
                        prop: "performance",
                        type: 'textarea',
                        span: 24,
                        placeholder: "父亲XXX陈述，XXX与邻里关系融洽，口碑较好，村里大多数认为他是个乖顺的孩子。"
                    }]
                },
                {
                    label: '案主对今后发展期望',
                    prop: 'bx',
                    column: [{
                        labelWidth: 0,
                        prop: "expectations",
                        type: 'textarea',
                        span: 24,
                        placeholder: "提示：xxx对未来生涯规划没有明确目标，表示希望家庭和睦"
                    }]
                },
                {
                    label: '家庭对其将来回归社会的支持态度',
                    prop: 'bx',
                    column: [{
                        labelWidth: 0,
                        prop: "support",
                        type: 'textarea',
                        span: 24,
                        placeholder: "xxx父亲表示日后会多与孩子沟通，注重培养孩子乐观的心态,教育其明辨是非的能力，增强法律意识"
                    }]
                }, {
                    label: '经综合分析，提出如下意见',
                    prop: 'bx',
                    column: [{
                        labelWidth: 0,
                        prop: "opinion",
                        type: 'textarea',
                        span: 24,
                        placeholder: "根据调查XXX个人情况、家庭状况、悔改表现、以及帮扶条件等情况。经综合分析，提出如下意见:案主XXX对本次事件有悔意及较强的心理压力，担忧返校后被同学和老师知道，影响学业和自尊心。由于家庭的教养方式对孩子有一定的控制倾向，导致XXX在主观行为规范、法律意识淡薄，有随从和从众的心理，缺乏主观见解和判断，但其父母较为年轻且收入较高较稳定，在对孩子教育引导和改善方面有一定的空间，建议对其犯罪行为从轻或减轻处罚。"
                    }]
                }, {
                    label: '计划单',
                    arrow: false,
                    prop: 'group5',
                    labelWidth: 0,
                    column: [{
                        prop: 'jhd',
                        span: 24,
                        row: true
                    }]
                }, {
                    label: '具体计划单',
                    arrow: false,
                    prop: 'group6',
                    labelWidth: 0,
                    column: [{
                        prop: 'detailInit',
                        span: 24,
                        row: true
                    }]
                }, {
                    detail: this.task ? true : false,
                    label: '公检司法相关凭证',
                    arrow: false,
                    prop: 'group7',
                    labelWidth: 0,
                    column: [{
                        prop: 'gjf',
                        span: 24,
                        row: true
                    }]
                }
                ]
            },

        }
    },
    mounted() {
        this.init()
        // let column2 = this.findObject(this.option.group, 'crimeType')
        // getDictTree().then(res => {
        //     let list = res.data.data.filter(v => v.code == 'crime_types')[0].children
        //     column2.dicData = list
        // })
        getDictionary({ code: "order_status" }).then(res => {
            const column = this.findObject(this.option.group, "starOrderStatusList");
            let list = res.data.data.filter(v => v.dictKey <= 100)
            column.dicData = list
        })
    },
    methods: {
        init() {
            this.obj = this.detail
            this.jtjhDetail = this.detail
            this.orderKinshipList = this.detail.orderKinshipList
            this.starOrderJudicialList = this.detail.starOrderJudicialList
            let column3 = this.findObject(this.examineOption.column, 'result')
            getDictionary({ code: (this.examineBtn ? "Initial-plan-review_statu" : "cooperative-agency_report") }).then(res => {
                column3.dicData = res.data.data
            })
            getDictionary({ code: "order_status" }).then(res => {
                const column = this.findObject(this.option.group, "starOrderStatusList");
                const column1 = this.findObject(this.option.group, "status");
                let list = res.data.data.filter(v => v.dictKey <= 100)
                column.dicData = list
                column1.dicData = list
            })
        },
        printHandle() {
            this.$Print('#test');
        },
        closeVisible() {
            this.$emit("close")
        },
        // 打印初始计划单
        submit(form, done) {
            let json = {
                orderId: this.obj.id,
                remark: form.remark,
                result: form.result * 1 == 1 ? 0 : 1
            }
            if (this.lastExamine) {
                auditTwoHandle(json).then(res => {
                    this.$message.success("已审核")
                    this.examinelVisible = false;
                    this.$emit("close")
                    done()
                }).catch(() => {
                    done()
                })

            } else if (this.examineBtn) {
                auditOneHandle(json).then(res => {
                    this.$message.success("已审核")
                    this.examinelVisible = false;
                    this.$emit("close")
                    done()
                }).catch(() => {
                    done()
                })
            }
        },
        manualCaseHandle() {
            this.$confirm('是否确定结案?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                orderManualCase(this.obj.id).then(res => {
                    this.$message.success('已结案');
                    this.closeVisible()
                })
            }).catch(() => {
                this.$message.info('已取消');
            });
        },
        openJtjhHandle(plan) {

            this.jtjhDetail = deepClone(this.detail)
            this.jtjhDetail.orderInitialPlanList = this.jtjhDetail.orderInitialPlanList.filter(v => v.id == plan.id)
            this.pdfljtVisible = true
        },
        examineSubmit(form, done) {
            let json = {
                orderId: this.detail.id,
                note: form.note,
                score: form.score
            }
            orderEvaluationHandle(json).then(res => {
                this.$message.success("评价成功")
                this.pfVisible = false;
                this.closeVisible()
                done()
                this.refreshChange()
            }).catch(() => {
                this.pfVisible = false;
                this.closeVisible()
                done()
            })
        },
    }
}

</script>
<style lang="scss">
// @import "@/styles/moudles/order.scss";
.order-detail-wrapper1 {
    .txt {
        font-size: 12px;
        color: #606266;
    }

    .el-form-item--small.el-form-item {
        margin-bottom: 0;
    }
}
</style>
